import Input from "./input.js";
// import CurrencyField from "./currency-field.js";
import DynamicField from "./dynamic-field.js";
import Form from "./form.js";
import Radio from "./Radio.vue";
import RadioGroup from "./RadioGroup.vue";
import PassengerRadio from "./passenger-radio.js";
import FormGroup from "./FormGroup.vue";
import CounterPicker from "./CounterPicker.vue";
import Select from "./Select.vue";
import TextArea from "./TextArea.vue";
import { registerComponents, vueUse } from "../../../utils/plugins";

const components = {
  vOldInput: Input,
  vDynamicField: DynamicField,
  // vCurrencyField: CurrencyField,
  vFormGroup: FormGroup,
  vCounterPicker: CounterPicker,
  vRadioOld: Radio,
  vPassengerRadio: PassengerRadio,
  vRadioGroupOld: RadioGroup,
  vWpSelect: Select,
  vWpForm: Form,
  vTextArea: TextArea
};

const VuePlugin = {
  install(Vue) {
    registerComponents(Vue, components);
  }
};

vueUse(VuePlugin);

export default VuePlugin;
